// Components
import { DownloadDocumentBtn } from "../../components/DownloadDocumentBtn";
// MUI imports
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export const InvoiceCardHeader = ({ heading, docNo }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">{heading}</Typography>
      <DownloadDocumentBtn
        docType={"PDF"}
        docNo={docNo}
        path="printpostedinvoice"
      />
    </Stack>
  );
};
